import axiosInst from "./config/axiosConfig";

export interface ConfigurationArchive {
  archiveId: string;
  serialNumber: string;
  uploadedAt: string;
  sizeBytes: number;
}

export type ArchiveDelivery = "auto" | "mqtt" | "polling";

export interface ConfigurationRestoreSupport {
  supported: boolean;
  reason?: string;
}

export interface RestoreResult {
  requestId: string;
  expiresAt: string;
  results: { serialNumber: string; delivery?: string; error?: string }[];
}

const path = "/beta/configurationArchives";

export async function getConfigurationRestoreSupport(targetSerialNumbers: string[]) {
  const response = await axiosInst.get<ConfigurationRestoreSupport>(path, {
    params: { restoreTargets: targetSerialNumbers.join(",") },
  });
  return response.data;
}

export async function listConfigurationArchives(serialNumber: string, cursor?: string) {
  const response = await axiosInst.get<{ archives: ConfigurationArchive[]; nextCursor?: string }>(path, {
    params: { serialNumber, cursor },
  });
  return response.data;
}

export async function downloadConfigurationArchive(serialNumber: string, archiveId: string) {
  const response = await axiosInst.get<{ downloadUrl: string }>(path, { params: { serialNumber, archiveId } });
  return response.data.downloadUrl;
}

export async function deleteConfigurationArchive(serialNumber: string, archiveId: string) {
  await axiosInst.delete(path, { params: { serialNumber, archiveId } });
}

export async function restoreConfigurationArchive(
  sourceSerialNumber: string,
  archiveId: string,
  targetSerialNumbers: string[],
  delivery: ArchiveDelivery,
) {
  const response = await axiosInst.post<RestoreResult>(path, {
    sourceSerialNumber,
    archiveId,
    targetSerialNumbers,
    delivery,
  });
  return response.data;
}

export async function pushFullConfigurationBackup(
  configFileBase64: string,
  targetSerialNumbers: string[],
  delivery: ArchiveDelivery,
) {
  const response = await axiosInst.post<RestoreResult>(
    path,
    { configFileBase64, targetSerialNumbers, delivery },
    { params: { source: "upload" } },
  );
  return response.data;
}
